// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__3m-hx","load2":"Spinner_load2__1i2Qv"};